import React, { useState } from 'react';
import { ChevronDown, Info } from 'lucide-react';
import { StakeholderImportExport } from './StakeholderImportExport';
import { OrganizationImportExport } from './OrganizationImportExport';
import { BulkOperations } from './BulkOperations';
import { BackupManagement } from '../backup/BackupManagement';
import { Card, SectionHeader } from '../ui';

const IMPORT_NOTES = [
  'Download a template, fill it in, then import it',
  'Required columns are marked in the template',
  'Emails must be valid addresses',
  'Status must be exactly DRAFT, PENDING, APPROVED or REJECTED',
  'Export can filter by status; leave it empty for all',
  'Large files take longer; every import is audit-logged',
];

export const DataImportExport: React.FC = () => {
  const [notesOpen, setNotesOpen] = useState(false);

  return (
    <div>
      <SectionHeader
        title="Import & export"
        aside={
          <button
            type="button"
            onClick={() => setNotesOpen((v) => !v)}
            aria-expanded={notesOpen}
            aria-controls="import-notes"
            className="inline-flex h-7 items-center gap-1 rounded-full px-2 text-[12px] text-neutral-500 transition-colors hover:bg-neutral-100 hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600/40"
          >
            <Info className="h-3.5 w-3.5" strokeWidth={1.75} />
            Rules
            <ChevronDown className={`h-3.5 w-3.5 transition-transform ${notesOpen ? 'rotate-180' : ''}`} strokeWidth={1.75} />
          </button>
        }
      />
      {notesOpen && (
        <ul id="import-notes" className="mb-3 animate-fade-up space-y-1 px-1 text-[12px] text-neutral-500">
          {IMPORT_NOTES.map((note) => (
            <li key={note} className="flex gap-2">
              <span className="mt-[7px] h-1 w-1 flex-shrink-0 rounded-full bg-neutral-300" aria-hidden="true" />
              {note}
            </li>
          ))}
        </ul>
      )}
      <Card divided>
        <StakeholderImportExport />
        <OrganizationImportExport />
        <BulkOperations />
      </Card>

      <div className="mt-8">
        <BackupManagement />
      </div>
    </div>
  );
};
